import { Products as e } from "@tameeni/shared-logic";
const a = {
  [e.CAR]: {
    englishLabel: "Car",
    englishFullLabel: "Car Insurance",
    arabicLabel: "السيارات",
    arabicFullLabel: "التأمين على السيارات",
    link: "https://www.tameeni.com/",
    getQuoteLink: "/UHome/PurchaseFlow",
    icon: "Motor",
    activeIcon: "MotorColored",
    englishDescription: "Get Comprehensive & TPL Insurance in a minuets... ",
    arabicDescription: "احصل على تأمين شامل وتأمين المسؤولية الطرف الثالث في دقائق..."
  },
  [e.HEALTH_SME]: {
    englishLabel: "SME Health",
    englishFullLabel: "SME Health",
    arabicLabel: "التأمين الصحي للمنشآت",
    arabicFullLabel: "التأمين الصحي للمنشآت",
    link: "https://www.tameeni.com/health-sme",
    getQuoteLink: "https://health.tameeni.com/v2/purchase-policy",
    icon: "Health",
    activeIcon: "HealthColored",
    englishDescription: "Convenient & Cost effective",
    arabicDescription: "مريح وفعال من حيث التكلفة"
  },
  [e.MEDICAL_MALPRACTICE]: {
    englishLabel: "Medical Malpractice",
    englishFullLabel: "Medical Malpractice Insurance",
    arabicLabel: "الأخطاء الطبية",
    arabicFullLabel: "التأمين ضد الأخطاء الطبية",
    link: "https://www.tameeni.com/mmp",
    getQuoteLink: "https://mmp.tameeni.com/ar/PolicyInfo/PolicyInfo?page=1&nextstepid=2",
    icon: "MMP",
    activeIcon: "MMPColored",
    englishDescription: "Get quote from 600,000+ Practitioner and 5+ IC's...",
    arabicDescription: "احصل على عرض أسعار من أكثر من 600,000 ممارس و5+ من خبراء IC..."
  },
  [e.HEALTH_INDIVIDUAL]: {
    englishLabel: "Domestic Helper",
    englishFullLabel: "Domestic Helper Insurance",
    arabicLabel: "العمالة المنزلية",
    arabicFullLabel: "تأمين العمالة المنزلية",
    link: "https://www.tameeni.com/health",
    getQuoteLink: "",
    icon: "Health",
    activeIcon: "HealthColored",
    englishDescription: "Domestic helper or Yourself and your family",
    arabicDescription: "المساعد المنزلي أو أنت وعائلتك"
  },
  [e.TRAVEL]: {
    englishLabel: "Travel",
    englishFullLabel: "Travel Insurance",
    arabicLabel: "السفر",
    arabicFullLabel: "تأمين السفر",
    link: "https://www.tameeni.com/travel",
    getQuoteLink: "https://travel.tameeni.com/travel-journey?step=1",
    icon: "Travel",
    activeIcon: "TravelColored",
    englishDescription: "Get Immediate Travel Insurance in Minutes...",
    arabicDescription: "احصل على تأمين السفر الفوري في دقائق..."
  },
  [e.PROTECTION_AND_SAVING]: {
    englishLabel: "Protection And Saving",
    englishFullLabel: "Protection And Saving",
    arabicLabel: "الحماية والادخار",
    arabicFullLabel: "الحماية والادخار",
    link: "https://www.tameeni.com/ps",
    getQuoteLink: "",
    icon: "Life",
    activeIcon: "LifeColored",
    isNew: !0,
    englishDescription: "Invest with less now, Cover the future for you and your family!",
    arabicDescription: "استثمر بأقل الآن، وغطِّ المستقبل لك ولعائلتك!"
  },
  [e.HOME]: {
    englishLabel: "Home",
    englishFullLabel: "Home Insurance",
    arabicLabel: "المنزل",
    arabicFullLabel: "التأمين على المنزل",
    link: "https://www.tameeni.com/home",
    getQuoteLink: "",
    icon: "Home",
    activeIcon: "HomeColored",
    isNew: !0,
    englishDescription: "Insure your home, and save your belongings!",
    arabicDescription: "أّمن منزلك، وحافظ على ممتلكاتك!"
  },
  [e.FLEET_SME]: {
    englishLabel: "Fleet",
    englishFullLabel: "SME Fleet Insurance",
    arabicLabel: "أُسطول السيارات",
    arabicFullLabel: "التأمين على أُسطول السيارات",
    link: "https://www.tameeni.com/fleet",
    getQuoteLink: "",
    icon: "Fleet",
    activeIcon: "FleetColored",
    isNew: !0,
    englishDescription: "Get Comprehensive & TPL Insurance in a minuets... ",
    arabicDescription: "احصل على تأمين شامل وتأمين المسؤولية الطرف الثالث في دقائق..."
  },
  [e.MARINE]: {
    englishLabel: "Marine",
    englishFullLabel: "Marine Insurance",
    arabicLabel: "البحري",
    arabicFullLabel: "التأمين البحري",
    link: "https://www.tameeni.com/marine",
    getQuoteLink: "",
    icon: "Marine",
    activeIcon: "MarineColored",
    isNew: !0,
    englishDescription: "Secure your marine, air, or land cargo, instantly",
    arabicDescription: "قم بتأمين بضائعك البحرية أو الجوية أو البرية على الفور"
  },
  [e.PREMIUM_RESIDENCY]: {
    englishLabel: "Premium Residency Health",
    englishFullLabel: "Premium Residency Health Insurance",
    arabicLabel: "تأمين الإقامة المميزة",
    arabicFullLabel: "تأمين الإقامة المميزة",
    link: "https://www.tameeni.com/health-pr",
    getQuoteLink: "https://qc-indv-health.gettameeni.com/en",
    icon: "Health",
    activeIcon: "HealthColored",
    englishDescription: "Premium Residency Health Insurance: We Care for Your Health",
    arabicDescription: "التأمين الصحي للإقامة المميزة: نحن نهتم بصحتك"
  }
};
export {
  a as tameeniProductsMap
};
//# sourceMappingURL=products.js.map
